import { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { cn } from '@/lib/utils'
import { X } from 'lucide-react'

export function AdminShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const { pathname } = useLocation()

  // Close mobile sidebar on route change
  useState(() => { setSidebarOpen(false) })

  // biome-ignore lint: pathname used to auto-close sidebar
  void pathname

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      {/* Desktop sidebar */}
      <aside className="hidden md:flex shrink-0">
        <Sidebar />
      </aside>

      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-40 md:hidden"
          role="dialog"
          aria-modal="true"
          aria-label="Navigation menu"
        >
          <div
            className="absolute inset-0 bg-background/80 backdrop-blur-sm"
            onClick={() => setSidebarOpen(false)}
            aria-hidden="true"
          />
          <div className="relative z-50 flex h-full">
            <Sidebar onClose={() => setSidebarOpen(false)} />
            <button
              className={cn(
                'absolute top-3 right-3 h-8 w-8 flex items-center justify-center',
                'rounded-[var(--radius)] border border-border bg-card text-muted-foreground',
                'hover:text-foreground transition-colors',
                'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
              )}
              onClick={() => setSidebarOpen(false)}
              aria-label="ปิดเมนู"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      )}

      {/* Main content */}
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        <Header onMenuToggle={() => setSidebarOpen(true)} />
        <main className="flex-1 overflow-y-auto animate-page-in" id="main-content">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
